<template>
    <div>
        <div class="bg-white rounded shadow-sm">
            <div class="card card-body border-0">
                <div class="d-flex align-items-center mb-4">
                    <h6 class="font-weight-bold ">Account Details</h6>
                </div>
                <div>
                    <form @submit.prevent="update" method="post">
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label>Account Type</label>
                                    <select disabled v-model="form.account_type" class="custom-select"
                                            :class="[ form.errors.get('account_type') ? 'is-invalid' : '' ]">
                                        <option :value="form.account_type" disabled>{{form.account_type}}</option>
                                        <option value="ZESA">ZESA</option>
                                        <option value="ECONET">ECONET</option>
                                        <option value="NETONE">NETONE</option>
                                    </select>
                                    <div v-text="form.errors.get('account_type')" class="invalid-feedback"/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label>Account Name</label>
                                    <input type="text" v-model="form.account_name"
                                           :class="[ 'form-control' , form.errors.get('account_name') ? 'is-invalid' : '' ]"
                                           placeholder="Enter account name">
                                    <div v-text="form.errors.get('account_name')" class="invalid-feedback"/>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>Account Number</label>
                                    <input type="text" v-model="form.account_number"
                                           :class="[ 'form-control' , form.errors.get('account_number') ? 'is-invalid' : '' ]"
                                           placeholder="Enter account number">
                                    <div v-text="form.errors.get('account_number')" class="invalid-feedback"/>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>Group Name</label>
                                    <div v-if="form.errors.get('group_name')" class="invalid-feedback d-block">
                                        {{ form.errors.get('group_name') }}
                                    </div>
                                    <div class="position-relative">
                                        <input
                                            type="text"
                                            v-model="form.group_name"
                                            class="form-control"
                                            placeholder="Enter or select a group name"
                                            @focus="openDropdown('group')"
                                            @input="filterItems"
                                            ref="groupDropdown"
                                            :disabled="!form.account_type"
                                        />
                                        <ul class="dropdown-menu w-100 show dropdown-scroll" v-show="showDropdown" ref="groupMenu">
                                            <li class="p-2 d-flex align-items-center">
                                                <input type="text" v-model="newGroupName" class="form-control mr-2" placeholder="Create new group" />
                                                <button class="btn btn-sm btn-primary" @click.prevent="saveNewGroup">Save</button>
                                            </li>
                                            <li v-for="(item, index) in filteredItems" :key="index">
                                                <a class="dropdown-item" @click="selectItem(item)">{{ item.group_name }}</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div v-if="form.errors.get('group_id')" class="invalid-feedback d-block">
                                        {{ form.errors.get('group_id') }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>Batch Name</label>
                                    <div v-if="form.errors.get('batch_name')" class="invalid-feedback d-block">
                                        {{ form.errors.get('batch_name') }}
                                    </div>
                                    <div class="position-relative">
                                        <input
                                            type="text"
                                            v-model="form.batch_name_display"
                                            class="form-control"
                                            placeholder="Enter or select a batch name"
                                            @focus="openDropdown('batch')"
                                            @input="filterBatchItems"
                                            ref="batchDropdown"
                                            :disabled="!form.group_id || !form.account_type"
                                        />
                                        <ul class="dropdown-menu w-100 show dropdown-scroll" v-show="showBatchDropdown" ref="batchMenu">
                                            <li class="p-2 d-flex align-items-center">
                                                <input type="text" v-model="newBatchName" class="form-control mr-2" placeholder="Create new batch" />
                                                <button class="btn btn-sm btn-primary" @click.prevent="saveNewBatch">Save</button>
                                            </li>
                                            <li v-for="(batch, index) in filteredBatchItems" :key="index">
                                                <a class="dropdown-item" @click="selectBatch(batch)">{{ batch.batch_name }}</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div v-if="form.errors.get('batch_id')" class="invalid-feedback d-block">
                                        {{ form.errors.get('batch_id') }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label>Contact Info</label>
                                    <input type="text" v-model="form.contact_info"
                                           :class="[ 'form-control' , form.errors.get('contact_info') ? 'is-invalid' : '' ]"
                                           placeholder="Enter contact info">
                                    <div v-text="form.errors.get('contact_info')" class="invalid-feedback"/>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-12">
                                <button @click.prevent="update"
                                        :class="['btn btn-primary btn-block mt-2', form.loading ? 'btn-loading' : '']"
                                        type="submit">Update Stored Account
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Form from "../../../core/forms/form";

export default {
    name: "EditStoredAccount",
    data() {
        return {
            form: new Form({
                account_name: '',
                account_number: '',
                account_type: '',
                group_id: null,
                group_name: '',
                batch_id: null,
                batch_name: '',
                contact_info: '',
            }),
            showDropdown: false,
            showBatchDropdown: false,
            newGroupName: '',
            newBatchName: '',
            items: [],
            batchItems: [],
            filteredItems: [],
            filteredBatchItems: [],
            id: this.$route.params.id,
            loading: false
        };
    },

    mounted() {
        document.addEventListener("click", this.handleClickOutside);
        this.fetchStoredAccount();
    },

    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutside);
    },
    watch: {
        'form.group_id'(newVal) {
            this.fetchBatches();
        },
        'form.account_type'(newVal) {
            this.fetchBatches();
            if (!this.form.batch_id) {
                this.form.batch_name_display = null;
            }
        }
    },
    methods: {

        handleClickOutside(event) {
            if (this.showDropdown && this.$refs.groupDropdown && !this.$refs.groupDropdown.contains(event.target) &&
                this.$refs.groupMenu && !this.$refs.groupMenu.contains(event.target)) {
                this.showDropdown = false;
            }

            if (this.showBatchDropdown && this.$refs.batchDropdown && !this.$refs.batchDropdown.contains(event.target) &&
                this.$refs.batchMenu && !this.$refs.batchMenu.contains(event.target)) {
                this.showBatchDropdown = false;
            }
        },

        filterItems() {
            this.filteredItems = this.items.filter(item =>
                item.group_name.toLowerCase().includes(this.form.group_name.toLowerCase())
            );
        },

        filterBatchItems() {
            this.filteredBatchItems = this.batchItems.filter(batch =>
                batch.batch_name.toLowerCase().includes(this.form.batch_name_display.toLowerCase())
            );
        },


        fetchStoredAccount() {
            axios.get(`/business/business-stored-accounts/${this.id}`)
                .then(response => {
                    let account = response.data.body.model;
                    this.form.account_name = account.account_name;
                    this.form.account_number = account.account_number;
                    this.form.account_type = account.account_type;
                    this.form.contact_info = account.contact_info;
                    this.form.group_id = account.group_id;
                    this.form.group_name = account.group_name;
                    this.form.batch_id = account.batch_id;
                    this.form.batch_name_display = account.batch_name;
                    this.fetchGroups();
                    this.fetchBatches();
                })
                .catch(error => {
                    console.error("Error fetching stored account:", error);
                });
        },

        openDropdown(type) {
            if (type === 'group') {
                this.showDropdown = true;
                this.fetchGroups();
            } else if (type === 'batch' && this.form.group_id) {
                this.showBatchDropdown = true;
                this.fetchBatches();
            }
        },

        fetchGroups() {
            axios.get("/business/business-stored-accounts/groups/list")
                .then(response => {
                    this.items = response.data.body.list.data;
                    this.filteredItems = this.items;
                })
                .catch(error => {
                    console.error("Error fetching groups:", error);
                });
        },

        fetchBatches() {
            if (!this.form.group_id || !this.form.account_type) return;
            axios.get(`/business/business-stored-accounts/groups/${this.form.group_id}/${this.form.account_type}/batches/list`)
                .then(response => {
                    this.batchItems = response.data.body.list.data;
                    this.filteredBatchItems = [...this.batchItems];
                })
                .catch(error => {
                    console.error("Error fetching batches:", error);
                });
        },

        selectItem(item) {
            this.form.group_id = item.id;
            this.form.group_name = item.group_name;
            this.showDropdown = false;
            this.form.batch_id = null;
            this.form.batch_name_display = null;
            this.fetchBatches();
            this.form.errors.clear('group_name');
            this.form.errors.clear('group_id');
        },

        selectBatch(batch) {
            this.form.batch_id = batch.id;
            this.form.batch_name_display = batch.batch_name;
            this.showBatchDropdown = false;
            this.form.errors.clear('batch_name');
            this.form.errors.clear('batch_id');
        },

        saveNewGroup() {
            if (this.newGroupName.trim() !== '') {
                this.form.fill('group_name', this.newGroupName);
                this.form.submit('/business/business-stored-accounts/groups/create')
                    .then(response => {
                        let newGroup = response.data.body.group;
                        this.items.push(newGroup);
                        this.selectItem(newGroup);
                        this.newGroupName = '';
                        this.fetchGroups();
                    })
                    .catch(error => {
                        console.error("Error saving group:", error);
                    });
            }
        },

        saveNewBatch() {
            if (this.newBatchName.trim() !== '' && this.form.group_id) {
                this.form.fill('batch_name', this.newBatchName);
                this.form.submit('/business/business-stored-accounts/batches/create')
                    .then(response => {
                        let newBatch = response.data.body.batch;
                        this.batchItems.push(newBatch);
                        this.selectBatch(newBatch);
                        this.newBatchName = '';
                        this.fetchBatches();
                    })
                    .catch(error => {
                        console.error("Error saving batch:", error);
                    });
            }
        },


        update() {
            this.form.submit(`/business/business-stored-accounts/${this.id}/update`)
                .then(() => {
                    this.$router.push(`/business/stored-accounts/${this.form.batch_id}/batch`);
                })
                .catch(error => {
                    console.error("Error updating stored account:", error);
                });
        }

    }
}
</script>
<style scoped>
.dropdown-scroll {
    max-height: 200px;
    overflow-y: auto;
}
</style>

